import { useEffect, useState } from "react";
import { FiltersToolbar } from "./FiltersToolbar";
import { FilterValues, IDynamicFilters, initializeFilterValues } from "./DynamicFilters.config";

export const DynamicFilters = (props: IDynamicFilters) => {

  const { filters, externalFilterValues, filterData } = props;

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [filterValues, setFilterValues] = useState<FilterValues>({});

  useEffect(() => {
    if (externalFilterValues && Object.keys(externalFilterValues).length > 0) {
      setFilterValues(externalFilterValues);
    } else {
      setFilterValues(initializeFilterValues(filters));
    }
  }, [externalFilterValues, filters]);

  const handleChange = (code: string, value: any) => {
    setFilterValues((prevValues: any) => ({
      ...prevValues,
      [code]: {
        ...prevValues[code],
        value,
      },
    }));
  };

  const removeEmptyKeys = (input: any) => {
    for (let key in input) {
        if (input[key].value === "") {
            delete input[key];
        }
    }
    return input;
}

  const applyFilters = () => {

    const noEmptyFilters = removeEmptyKeys(filterValues);
    filterData(noEmptyFilters);
    setAnchorEl(null);
  };

  const resetFilters = () => {
    const resetValues = initializeFilterValues(filters);
    setFilterValues(resetValues); // Limpia el estado local de filtros
    if (props.resetGlobalFilters) {
      props.resetGlobalFilters();
    }
    filterData({}); // Limpia el estado global de filtros (vía Redux)
    // Llama a la acción Redux para limpiar filtros provisionales
    setAnchorEl(null);
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <FiltersToolbar
        anchorEl={anchorEl}
        filters={filters}
        filterValues={filterValues}
        handleChange={handleChange}
        onOtherComponentChange={props.onOtherComponentChange}        
        handleOpenMenu={handleOpenMenu}
        handleCloseMenu={handleCloseMenu}
        resetFilters={resetFilters}
        applyFilters={applyFilters}
      />
    </div>
  );
};
